import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportAvaliacaoHabilidadeUseCase } from "../../../presentation/useCases/read/get_report_avaliacao_habilidade_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportAvaliacaoHabilidadeUseCase
 */

export class GetReportAvaliacaoHabilidadeUseCase implements IGetReportAvaliacaoHabilidadeUseCase {
  constructor(
    private readonly repository: IReportsRepository,
  ) { }

  async getReportAvaliacaoHabilidade(
    requiredMimeType: ReportMimeType | null,
    idAvaliacaoHabilidade: number,
  ): Promise<ReportData> {
    const response = await this.repository.getRelatorioAvaliacaoHabilidade(
      requiredMimeType,
      idAvaliacaoHabilidade,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `avaliacao_habilidade_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}